import { Dispatch, SetStateAction } from 'react'
import { IParentFormData } from '../contexts/ParentFormDataContext'

//Used in ParentGuardian and PolicyBooking
export const handleDDLFocus = (
    parentFormData: IParentFormData,
    setParentFormData: Dispatch<SetStateAction<IParentFormData>>,
    e: React.FocusEvent<HTMLInputElement>
) => {
    const { name } = e.target
    const dataInput = parentFormData.ParentFormDataInput.find(
        (x) => x.Name === name
    )

    if (dataInput != null) {
        const updatedTemp = { ...dataInput, IsBlur: false, IsFocus: true }
        const updatedFormInputs = [...parentFormData.ParentFormDataInput]
        const index = updatedFormInputs.indexOf(dataInput)
        updatedFormInputs[index] = updatedTemp
        setParentFormData((prevState) => ({
            ...prevState,
            ParentFormDataInput: updatedFormInputs,
        }))
    }
}
